import styled from '@emotion/styled';
import { fonts, media, pxToRem, sunriseSemanticTokens, theme } from '@vfit/shared/themes';

export const ConsumerModalContent = styled.div`
  width: 100%;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  align-items: center;

  height: calc(100vh - ${pxToRem(66)});
  max-height: calc(100vh - ${pxToRem(66)});
  overflow: hidden;
  min-height: 0;
  padding: ${pxToRem(16)} ${pxToRem(44)};
  margin-top: ${theme.spacing.md};

  ${media.tablet`
    width: 600px;
  `}

  ${media.largeDesktop`
    width: 842px;
    height: calc(100vh - ${pxToRem(56)} - ${pxToRem(64)});
    max-height: calc(100vh - ${pxToRem(56)} - ${pxToRem(64)});
    overflow: hidden;
    padding: ${pxToRem(24)} ${pxToRem(109)} ${pxToRem(64)};
    margin-top: ${theme.spacing.lg};
  `}
`;

export const ConsumerModalBody = styled.div`
  width: 100%;
  box-sizing: border-box;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: ${theme.spacing.xl};
  flex: 1;
  min-height: 0;
  margin: 0;
`;

export const ModalTitle = styled.p`
  color: ${sunriseSemanticTokens.colors.text.primary};
  font-family: ${fonts.vodafone};
  font-size: ${pxToRem(30)};
  font-style: normal;
  font-weight: ${theme.typography.fontWeight.extrabold};
  line-height: ${pxToRem(38)};
  margin: 0;
  text-align: left;
  margin-top: ${theme.spacing.sm};

  * {
    margin: 0;
  }

  ${media.largeDesktop`
      font-size: ${theme.typography.fontSize.display4};
      line-height: ${pxToRem(45)};
      margin-top: ${theme.spacing.lg};
  `}
`;

export const ModalText = styled.div`
  color: ${sunriseSemanticTokens.colors.text.primary};
  font-family: ${fonts.vodafone};
  font-size: ${theme.typography.fontSize.body2};
  font-style: normal;
  font-weight: ${theme.typography.fontWeight.regular};
  line-height: ${theme.typography.lineHeight.body2};
  text-align: left;

  width: 100%;

  p {
    margin: 0;
  }

  ${media.largeDesktop`
    font-size: ${theme.typography.fontSize.body1};
    line-height: ${theme.typography.lineHeight.body1};
  `}
`;

export const ConsumerModalScrollableContent = styled.div`
  width: calc(100% + ${pxToRem(25)});
  flex: 1;
  min-height: 0;

  overflow-y: auto;
  overflow-x: hidden;

  padding-right: ${pxToRem(25)};
  box-sizing: border-box;

  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
`;

